import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 1024F530-CFE4-4869-BAA4-062593D42DC9
 * name bucket
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bucket.svg
 * tags
 */
export const BucketIcon = createSvgIcon(<><path d="M3 4H21V7H20L17.5 21H6.5L4 7H3V4Z" /></>, 'BucketIcon');
export default BucketIcon